import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'highlightSearch' })
export class HighlightSearchPipe implements PipeTransform {

  transform(value: any, args: any): any {
    if (value && args && args.trim() && !args.includes('., \, +, *, ?, [, ^, ], $, (, ), {, }, =, !, <, >, |, :, -')) {
      return value.replace(new RegExp( '(' + args + ')', 'gi'), '<b>$1</b>');
    }
    return value;
  }

}
